var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"format":_vm.formatDatePicker,"value-type":"timestamp","type":"datetime","show-second":false},model:{value:(_vm.localTimestamp),callback:function ($$v) {_vm.localTimestamp=$$v},expression:"localTimestamp"}})}
var staticRenderFns = []

export { render, staticRenderFns }